import {createRouter, createWebHistory} from 'vue-router';

let appPages = [
    {
        path: "/website",
        component: () => import("@/apps/pages/WebsiteScore")
    }
];

const routes = [
    {
        path: '/',
        redirect: '/website',
        component: () => import("@/apps/pages/WebsiteIndex"),
        children: appPages
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});
export default router;